import { blueColor } from "@/constants/colors";
import { css } from "@emotion/react";
import { useState, useEffect } from "react";
import facebookIcon from "../../../public/images/blog-post/facebook-big.png";
import twitterIcon from "../../../public/images/blog-post/twitter-big.png";
import Image from "next/image";
import Link from "next/link";
import { mq } from "@/constants/breakpoints";

const Wrapper = ({
  href,
  iconSrc,
  iconAlt,
}: {
  href: string;
  iconSrc: any;
  iconAlt: string;
}) => (
  <Link
    href={href}
    css={css`
      display: block;
      width: fit-content;
    `}
  >
    <div
      css={css`
        border: 2px solid ${blueColor};
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        transition: all 0.2s ease-in-out;
        background: transparent;
        &:hover {
          border-color: #c0e7fd;
        }
        &:active {
          background: ${blueColor};
        }
      `}
    >
      <Image src={iconSrc} alt={iconAlt} />
    </div>
  </Link>
);

interface SocialSharingProps {
  title: string;
}

const SocialSharing = ({ title }: SocialSharingProps) => {
  const [showIcon, setShowIcon] = useState(false);

  const url = window.location.href;
  const encodedUrl = encodeURIComponent(url);
  const encodedTwitterTitle = encodeURIComponent(`${title} via @Jersey_Watch`);
  const twitterHref = `http://twitter.com/intent/tweet?text=${encodedTwitterTitle}&url=${encodedUrl}`;
  const facebookHref = `http://www.facebook.com/share.php?u=${encodedUrl}`;

  useEffect(() => {
    function handleScroll() {
      const blogContainer = document.getElementById("blog-container");
      const signupContainer = document.getElementById("signup-cta-container");

      if (blogContainer && signupContainer) {
        const { top: blogTop } = blogContainer.getBoundingClientRect();
        const { top: signupTop } = signupContainer.getBoundingClientRect();
        if (
          window.innerHeight - blogTop >= 200 &&
          signupTop + 60 > window.innerHeight
        ) {
          setShowIcon(true);
        } else {
          setShowIcon(false);
        }
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div
        className={`scroll-icon-container ${showIcon ? "scrolled-down" : ""}`}
        css={css`
          margin: 60px auto;
          display: flex;
          gap: 24px;
          justify-content: center;
          ${mq["lg"]} {
            position: fixed;
            bottom: -200px;
            right: 40px;
            justify-content: flex-start;
            flex-direction: column;
            gap: 30px;
            transition: bottom 0.1s ease-in-out;
          }
        `}
      >
        <Wrapper
          href={facebookHref}
          iconSrc={facebookIcon}
          iconAlt="Share on Facebook"
        />
        <Wrapper
          href={twitterHref}
          iconSrc={twitterIcon}
          iconAlt="Share on Twitter"
        />
      </div>
      <style global jsx>{`
        .scroll-icon-container.scrolled-down {
          bottom: 50px;
        }
      `}</style>
    </>
  );
};

const SocialSharingContainer = (props: SocialSharingProps) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  if (!loaded) return null;
  return <SocialSharing {...props} />;
};

export default SocialSharingContainer;
